import React, { useEffect, useState } from 'react';

import VideoIcon from 'src/assets/svg/video_black_24.svg?react';

import HelpPopup from 'src/shared/components/help-popup/HelpPopup';
import { useLocation } from 'react-router-dom';
import cmsService from 'src/services/cms-service';
import classNames from 'classnames';
import styles from './VideoHelp.module.scss';

const VideoHelp = () => {
    const { pathname } = useLocation();
    const [articleContent, setArticleContent] = useState<string | null>(null);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchArticleContent = async () => {
            // Skip login pages and very short paths
            if (pathname.length <= 2 || pathname.includes('login')) {
                return;
            }

            // Create a more robust slug generation
            const slug = 'video-article' + pathname.replaceAll('/', '-');

            // Skip if slug is malformed (ends with just a dash)
            if (slug.endsWith('-') && slug.length <= 'video-article-'.length) {
                // Skip logging for malformed slugs to reduce noise
                return;
            }

            setIsLoading(true);
            try {
                const article = await cmsService.getArticleBySlug(slug);
                if (article && article.content) {
                    setArticleContent(article.content);
                }
                // Skip logging when no content is found - this is expected behavior
            } catch (error: any) {
                if (error.status !== 404) {
                    // Only log non-404 errors as these are unexpected
                    console.error('Failed to fetch video help article:', {
                        error,
                        pathname,
                        slug,
                        status: error.status,
                    });
                }
                // 404 errors are expected and don't need logging
            } finally {
                setIsLoading(false);
            }
        };

        fetchArticleContent();

        return () => {
            setArticleContent(null);
            setIsLoading(false);
        };
    }, [pathname]);

    // Don't render if no content or still loading
    if (!articleContent || isLoading) {
        return null;
    }

    const iconPlacement = pathname.startsWith('/map') ? 'top' : 'Bottom';

    const wrapperClassNames = classNames(styles.videoHelp, {
        [styles.videoHelpTop]: iconPlacement === 'top',
        [styles.videoHelpOpen]: isPopupOpen,
    });

    const videoIcon = (
        <div className={styles.videoHelpController}>
            <div className={styles.videoHelpControllerText}>Watch video</div>
            <div className={styles.videoHelpControllerIcon}>
                <VideoIcon />
            </div>
        </div>
    );

    return (
        <div className={wrapperClassNames}>
            <HelpPopup label={videoIcon} onClose={() => setPopupOpen(false)} onOpen={() => setPopupOpen(true)}>
                <div className={styles.videoHelpContent}>
                    <div dangerouslySetInnerHTML={{ __html: articleContent }}></div>
                </div>
            </HelpPopup>
        </div>
    );
};

export default VideoHelp;
